interface IconProps {
  size?: number;
  className?: string;
}

// Success Icon (Check Circle Fill - green)
export function SuccessIcon({ size = 1.5, className = "" }: IconProps) {
  return (
    <svg
      width={`${size}rem`}
      height={`${size}rem`}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={`text-text-success shrink-0 ${className}`}
    >
      <path d="m 12,2.25 c -5.3851246,0 -9.75,4.3648754 -9.75,9.75 0,5.384095 4.3648154,9.75 9.75,9.75 5.385195,0 9.75,-4.365905 9.75,-9.75 0,-5.3851246 -4.364905,-9.75 -9.75,-9.75 z m 3.462891,6.6914063 c 0.191924,0 0.382847,0.0723 0.529297,0.21875 0.292899,0.2928897 0.292899,0.7696402 0,1.0624997 L 11.375,14.839844 c -0.2928,0.292899 -0.767647,0.292799 -1.060547,0 L 8.0058594,12.53125 c -0.2929597,-0.2928 -0.2947829,-0.767647 -0.00195,-1.060547 0.2928197,-0.293 0.7675871,-0.2928 1.0605468,0 l 1.7812498,1.777344 4.085938,-4.0878907 c 0.146449,-0.1464499 0.339325,-0.21875 0.53125,-0.21875 z" />
    </svg>
  );
}

// Error Icon (Warning Circle Fill - red)
export function ErrorIcon({ size = 1.5, className = "" }: IconProps) {
  return (
    <svg
      width={`${size}rem`}
      height={`${size}rem`}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={`text-text-negative shrink-0 ${className}`}
    >
      <path d="m 12,2.25 c -5.3851246,0 -9.75,4.3648754 -9.75,9.75 0,5.384095 4.3648154,9.75 9.75,9.75 5.385195,0 9.75,-4.365905 9.75,-9.75 0,-5.3851246 -4.364905,-9.75 -9.75,-9.75 z m -0.0039,5.3066406 c 0.414199,0 0.75,0.3357904 0.75,0.75 v 4.2988284 c 0,0.414199 -0.335801,0.75 -0.75,0.75 -0.4142,0 -0.75,-0.335801 -0.75,-0.75 V 8.3066406 c 0,-0.4142096 0.3358,-0.75 0.75,-0.75 z M 12,14.943359 c 0.4142,0 0.75,0.335801 0.75,0.75 v 0.04883 c 0,0.414199 -0.3358,0.749999 -0.75,0.749999 -0.4142,0 -0.75,-0.3358 -0.75,-0.749999 v -0.04883 c 0,-0.414199 0.3358,-0.75 0.75,-0.75 z" />
    </svg>
  );
}

// Warning Icon (same as Error but orange color)
export function WarningIcon({ size = 1.5, className = "" }: IconProps) {
  return (
    <svg
      width={`${size}rem`}
      height={`${size}rem`}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={`text-text-warning shrink-0 ${className}`}
    >
      <path d="m 12,2.25 c -5.3851246,0 -9.75,4.3648754 -9.75,9.75 0,5.384095 4.3648154,9.75 9.75,9.75 5.385195,0 9.75,-4.365905 9.75,-9.75 0,-5.3851246 -4.364905,-9.75 -9.75,-9.75 z m -0.0039,5.3066406 c 0.414199,0 0.75,0.3357904 0.75,0.75 v 4.2988284 c 0,0.414199 -0.335801,0.75 -0.75,0.75 -0.4142,0 -0.75,-0.335801 -0.75,-0.75 V 8.3066406 c 0,-0.4142096 0.3358,-0.75 0.75,-0.75 z M 12,14.943359 c 0.4142,0 0.75,0.335801 0.75,0.75 v 0.04883 c 0,0.414199 -0.3358,0.749999 -0.75,0.749999 -0.4142,0 -0.75,-0.3358 -0.75,-0.749999 v -0.04883 c 0,-0.414199 0.3358,-0.75 0.75,-0.75 z" />
    </svg>
  );
}

// Info Icon (Info Circle Fill - purple/primary)
export function InfoIcon({ size = 1.5, className = "" }: IconProps) {
  return (
    <svg
      width={`${size}rem`}
      height={`${size}rem`}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={`text-text-primary shrink-0 ${className}`}
    >
      <path d="m 12,2.25 c -5.3851246,0 -9.75,4.3648754 -9.75,9.75 0,5.384095 4.3648154,9.75 9.75,9.75 5.385195,0 9.75,-4.365905 9.75,-9.75 0,-5.3851246 -4.364905,-9.75 -9.75,-9.75 z m -0.0039,5.3066406 c 0.414199,0 0.75,0.3357904 0.75,0.75 v 4.2988284 c 0,0.414199 -0.335801,0.75 -0.75,0.75 -0.4142,0 -0.75,-0.335801 -0.75,-0.75 V 8.3066406 c 0,-0.4142096 0.3358,-0.75 0.75,-0.75 z M 12,14.943359 c 0.4142,0 0.75,0.335801 0.75,0.75 v 0.04883 c 0,0.414199 -0.3358,0.749999 -0.75,0.749999 -0.4142,0 -0.75,-0.3358 -0.75,-0.749999 v -0.04883 c 0,-0.414199 0.3358,-0.75 0.75,-0.75 z" />
    </svg>
  );
}

// Loading Icon (Spinner) — color inherited from parent via currentColor
export function LoadingIcon({ size = 1.5, className = "" }: IconProps) {
  return (
    <svg
      width={`${size}rem`}
      height={`${size}rem`}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`animate-spin shrink-0 ${className}`}
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  );
}
